//////////////////////////////////////////////////////////////////////
//
//  10/12/18
//  src/containers/LinkRow.js
//
//  This file will format a single row of Links to navigate between windows.
//

import React, { Component } from 'react';
import { COCKTAIL, BEER, RESTAURANT, MUSIC, LinkSingle } from "./LinkSingle";
import { setBoth } from "../store/actions/navbar";
import './LinkRow.css';

class LinkRow extends Component {
  clickIcon = ev => {
  //console.log( "LinkRow - clickIcon " );
  //console.log( ev );
  //console.dir( ev.target );
  //console.log( typeof ev.target );
  //console.dir( ev.target.className );
  //console.log( typeof ev.target.className );

    //  Note:  If ANYTHING is changed or added then we MUST make changes 
    //  here to keep everything in sync.
    var found  = 0;
    var search = "grills";

    if( ev.target.className.indexOf( COCKTAIL   ) >= 0 ) { found = 1; }
    if( ev.target.className.indexOf( BEER       ) >= 0 ) { found = 2; }
    if( ev.target.className.indexOf( RESTAURANT ) >= 0 ) { found = 3; }
    if( ev.target.className.indexOf( MUSIC      ) >= 0 ) { found = 4; }

    if( found > 0 ) {
      switch( found ) {
      case 1:   console.log( "Found Bars"            );   search="bars";      break;
      case 2:   console.log( "Found Bar and Grills"  );   search="grills";    break;
      case 3:   console.log( "Found Restaurants"     );   search="rests";     break;
      case 4:   console.log( "Found Music"           );   search="music";     break;
      default:  console.log( "Nothing Found: "+found );   search="grills";    break;
      }
      this.props.dispatch( setBoth( "page", search ) );
    } else {
      console.log( "Did not find anything." );
    }
  }

  render() {
    console.log( "LinkRow: " );
    console.log( this.props );

    return (
      <div className="LRowTop">
        <span className="LRowIcon"    onClick={ this.clickIcon } >
          <LinkSingle icolor="green"  type={ COCKTAIL } /></span>

        <span className="LRowIcon"    onClick={ this.clickIcon } >
          <LinkSingle icolor="red"    type={ BEER }/></span>

        <span className="LRowIcon"    onClick={ this.clickIcon } >
          <LinkSingle icolor="blue"   type={ RESTAURANT }/></span>

        <span className="LRowIcon"    onClick={ this.clickIcon } >
          <LinkSingle icolor="purple" type={ MUSIC }/></span>
      </div>
    );
  }
}

export default LinkRow;




// WEBPACK FOOTER //
// ./src/components/LinkRow.js